import { render, staticRenderFns } from "./BasicSelectionDialog.vue?vue&type=template&id=a6e0d00a"
import script from "./BasicSelectionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicSelectionDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports